<template>
  <div id="chatter-snippet-list" style="position: relative;">
    <!-- spinner -->
    <loading :active.sync="loading" :is-full-page="false"></loading>
    <!-- /spinner -->

    <!-- Card -->
    <b-card>
      <!-- Card header -->
      <template #header>
        <h3>Snippet List</h3>
      </template>
      <!-- /Card header -->

      <!-- Card body -->
      <template #default>
        <b-container fluid>
          <b-row align-h="between"
                 align-v="center"
                 class="mb-4">
            <!-- Filter -->
            <b-col cols="8">
              <b-form class="d-flex align-items-center"
                      @submit.prevent="reload">
                <b-row>
                  <b-col>
                    <label for="processName"
                           class="mr-2">Process Name</label>
                    <b-form-input id="processName"
                                  name="processName"
                                  type="text"
                                  v-model="filters.processName"
                                  @keyup.enter="reload"></b-form-input>
                  </b-col>
                  <b-col>
                    <label for="version"
                           class="mr-2">Version</label>
                    <b-form-input id="version"
                                  name="version"
                                  type="text"
                                  v-model="filters.version"
                                  @keyup.enter="reload"></b-form-input>
                  </b-col>
                  <b-col>
                    <label for="description"
                           class="mr-2">Description</label>
                    <b-form-input id="description"
                                  name="description"
                                  type="text"
                                  v-model="filters.version"
                                  @keyup.enter="reload"></b-form-input>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <!-- /Filter -->

            <!-- Action buttons -->
            <b-col cols="2"
                   class="d-flex justify-content-end">
              <b-button variant="success"
                        @click="pushRoute('/chatter/code/snippets/form')">Create
              </b-button>
            </b-col>
            <!-- /Action buttons -->
          </b-row>
        </b-container>

        <section v-if="data"
                 class="mx-auto">
          <!-- List -->
          <div class="table-wrapper">
            <b-table bordered
                     hover
                     selectable
                     @row-clicked="viewDetail"
                     head-variant="light"
                     :items="data"
                     :fields="fields">
            </b-table>
          </div>
          <!-- /List -->
        </section>
      </template>
      <!-- /Card body -->

      <template #footer>
        <div class="overflow-auto w-100 p-0 d-flex align-items-center justify-content-around">
          <b-pagination
            class="mb-0"
            v-model="pageInfo.curr"
            :total-rows="pageInfo.total"
            :per-page="pageInfo.perPage"
            :limit="7"
            align="center"
          ></b-pagination>
        </div>
      </template>

    </b-card>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';

export default {
  components: { Loading },
  data() {
    return {
      curr: 1,
      loading: false,
      title: null,
      data: null,
      filters: {
        processName: '',
        version: '',
        description: ''
      },
      fields: [
        { key: 'processName', label: 'Process Name' },
        { key: 'version', label: 'Version' },
        { key: 'description', label: 'Description' },
        { key: 'creatorId', label: 'Creator' },
        { key: 'creationDate', label: 'Creation Date' },
        { key: 'updater', label: 'Updater' },
        { key: 'updatedDate', label: 'Updated Date' },
      ],
      pageInfo: {
        curr: 1,
        perPage: 20,
        total: null,
      }
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      try {
        this.loading = true;

        // Construct query parameters
        let params = {};

        // Page info
        params.pageNum = this.pageInfo.curr;
        params.pageSize = this.pageInfo.perPage;

        // Filters
        this.filters.processName && (params.processName = this.filters.processName);
        this.filters.version && (params.version = this.filters.version);
        this.filters.description && (params.description = this.filters.description);

        // Get snippet list
        let response = await axios.get('/code/retrieveSnippetList', {
          headers: { Authorization: accessToken() },
          params
        });

        this.data = response.data.list;
        this.pageInfo.total = response.data.total;
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    viewDetail(row) {
      this.pushRoute(`/chatter/code/snippets/form?processName=${row.processName}&version=${row.version}`);
    }
  }
}
</script>

<style>
.table-wrapper {
    overflow-x: scroll;
    white-space: nowrap;
}

.table-wrapper table {
    width: auto;
    min-width: 100%;
}

#chatter-snippet-list button {
    height: inherit !important;
}

#chatter-snippet-list .card {
    min-height: 90vh;
}

#chatter-snippet-list .card-body {
    width: 100%;
}

#chatter-snippet-list .card-footer {
    position: sticky;
    left: 0;
    bottom: 0;
    background-color: #f8f8f8;
}
</style>
